import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/**
 * `GET /imports/{id}/mercure` : le jeton d'abonnement au fil de CET import.
 *
 * Le `topic` vient AVEC le jeton, et ce n'est pas une commodité : il faut le passer en
 * paramètre d'URL au hub, et le reconstruire ici demanderait de réécrire le format d'URN de la
 * plateforme en TypeScript. Une URN mal reformée ne lève aucune erreur — elle abonne
 * simplement à un topic où rien n'arrive.
 */
@doc.path('/imports/{id}/mercure')
export default class ImportMercureModel extends MapServiceModel {
	@doc.string declare token: string;
	@doc.string declare topic: string;
}
